import type { DbColumn } from '@/model/types';

/** What a database column's summary rows can do. Shared by the wizard and the title menu. */
export const DB_AGGS: { id: DbColumn['agg']; label: string }[] = [
  { id: 'auto', label: 'Auto' },
  { id: 'sum', label: 'Sum' },
  { id: 'avg', label: 'Average' },
  { id: 'weighted', label: 'Weighted average' },
  { id: 'min', label: 'Min' },
  { id: 'max', label: 'Max' },
  { id: 'count', label: 'Count' },
  { id: 'countUnique', label: 'Count unique' },
  { id: 'first', label: 'Value' },
];
